import { bookApi } from "./api.js";

const MODE_KEY = "converter_mode";
const ON_KEY   = "converter_on";

export function enableConverterMode() {
  try {
    sessionStorage.setItem(MODE_KEY, "1");
    if (sessionStorage.getItem(ON_KEY) === null) {
      sessionStorage.setItem(ON_KEY, "1");   // по умолчанию ВКЛ
    }
  } catch (e) {}
}

export function disableConverterMode() {
  try {
    sessionStorage.removeItem(MODE_KEY);
    sessionStorage.removeItem(ON_KEY);
  } catch (e) {}
}

export function isConverterMode() {
  try {
    return sessionStorage.getItem(MODE_KEY) === "1";
  } catch (e) {
    return false;
  }
}

export function getConvertOn() {
  try {
    const v = sessionStorage.getItem(ON_KEY);
    return v === null ? true : v === "1";   // по умолчанию ВКЛ, когда режим активен
  } catch (e) {
    return true;
  }
}

export function setConvertOn(on) {
  try {
    sessionStorage.setItem(ON_KEY, on ? "1" : "0");
  } catch (e) {}
}

// На десктопе HEIC часто приходит с пустым type, поэтому проверяем ещё и расширение имени.
export function isHeicFile(file) {
  if (!file) return false;
  const type = (file.type || "").toLowerCase();
  if (type === "image/heic" || type === "image/heif") return true;
  const name = (file.name || "").toLowerCase();
  return /\.(heic|heif)$/.test(name);
}

/**
 * Конвертирует HEIC/HEIF → PNG (PNG lossless, качество не теряется). Возвращает новый File.
 * Не-HEIC файлы возвращает как есть. Бросает Error, если декодировать не удалось.
 */
export async function convertHeicToPng(file) {
  if (!isHeicFile(file)) return file;
  let blob;
  try {
    blob = await bookApi.convertHeic(file);   // конвертация на сервере (libheif) — надёжно
  } catch (e) {
    console.error("Конвертация HEIC на сервере не удалась:", e);
    throw new Error("heic_convert_failed");
  }
  if (!blob) throw new Error("heic_convert_failed");
  const newName = (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg";
  return new File([blob], newName, { type: "image/jpeg", lastModified: Date.now() });
}